/**
 * Base64url encoding/decoding utilities for WebAuthn credential flows.
 *
 * WebAuthn APIs exchange binary data as ArrayBuffers, while the server
 * expects/returns base64url-encoded strings. These helpers bridge the two.
 *
 * @module lib/webauthn
 */

// ---------------------------------------------------------------------------
// Encoding
// ---------------------------------------------------------------------------

export function arrayBufferToBase64url(buffer: ArrayBuffer): string {
	const bytes = new Uint8Array(buffer);
	let binary = '';
	for (let i = 0; i < bytes.length; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// ---------------------------------------------------------------------------
// Decoding
// ---------------------------------------------------------------------------

export function base64urlToArrayBuffer(str: string): ArrayBuffer {
	const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
	const pad = base64.length % 4;
	const padded = pad ? base64 + '='.repeat(4 - pad) : base64;
	const binary = atob(padded);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes.buffer;
}
